import styled, { css } from 'styled-components'

export const ModalContent = styled.div<{ $alignLeft?: boolean }>`
  padding: 20px 0 8px;
  text-align: ${({ $alignLeft }) => ($alignLeft ? 'left' : 'center')};
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
`

export const SpinWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
`

export const Description = styled.p<{ $alignLeft?: boolean }>`
  margin: 0 0 16px;
  color: #363636;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: ${({ $alignLeft }) => ($alignLeft ? 'left' : 'inherit')};
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  ${({ $alignLeft }) =>
    $alignLeft &&
    css`
      white-space: normal;
      overflow-wrap: break-word;
      word-wrap: break-word;
      word-break: break-word;
    `}
`

export const Counter = styled.div`
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #213f68;
  margin-bottom: 12px;
`

export const ProgressWrapper = styled.div`
  max-width: 420px;
  margin: 0 auto;
`
